import ProductRow from './ProductRow/ProductRow'

const TableBody = ({ products, onClickInItem, currency, selectedProducts, onCheckProduct }) => {
  return (
    <tbody>
      {products?.map((product, index) => (
        <ProductRow
          key={product.id}
          position={index + 1}
          product={product}
          onClickInItem={onClickInItem}
          currency={currency}
          selected={selectedProducts?.includes(product.id)}
          onCheckProduct={onCheckProduct}
        />
      ))}
    </tbody>
  )
}

export default TableBody
